import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import AssetStore from '../../stores/AssetStore';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import AssetForm, { validate } from './AssetForm';
import { discardAssetDraft, saveAndDiscardAsset } from '../../actions/AssetActionCreator';

class AssetEditDialog extends Component {

    render() {
        const { draft } = this.state;
        if (!draft) { return null; }
        const errors = !!draft && validate(draft);
        const { onCancel, onSave, buttonText, ...formProps } = this.props;
        const title = this.props.title || (!!draft && draft.id ? 'Edit asset' : 'Create asset');

        return (
            <Dialog
                title={title}
                open={!!draft}
                actions={[
                    <FlatButton key="cancel" label="Cancel" onTouchTap={onCancel} />,
                    <FlatButton
                        key="submit"
                        label={buttonText}
                        disabled={this.state.isFetching || (Object.values(errors).length > 0)}
                        onTouchTap={onSave}
                    />
                ]}
                onRequestClose={onCancel}
            >
                <AssetForm draft={draft} errors={errors} allowWysiwyg={!!draft && draft.type && draft.type.name === 'text'} {...formProps} />
                {!!this.state.isFetching && <LinearProgress />}
            </Dialog>
        );
    }
}

AssetEditDialog.getStores = () => ([AssetStore]);
AssetEditDialog.calculateState = (prevState) => ({
    draft: AssetStore.getDraft(),
    isFetching: AssetStore.isFetching(),

});

AssetEditDialog.propTypes = {
    title: PropTypes.string,
    buttonText: PropTypes.string,
    onSave: PropTypes.func,
    onCancel: PropTypes.func,

    allowedTypes: PropTypes.array,
    allowWysiwyg: PropTypes.bool,
};

AssetEditDialog.defaultProps = {
    buttonText: 'Save',
    onSave: saveAndDiscardAsset,
    onCancel: discardAssetDraft,
};

export default Container.create(AssetEditDialog);
